<div
  class="_wl-header"
  [ngClass]="{
    '_wl-header--not-main': notMain
  }"
  [ngStyle]="{
    color: '#fff',
    'background-color': appConfig.settings.header_color
      ? appConfig.settings.header_color
      : '#ffffff'
  }"
>
  <ng-container *ngIf="isBrowser">
    <a
      *ngIf="appConfig.settings.header_menu[0] && !notMain"
      [href]="appConfig.settings.header_menu[0].link"
    >
      <div class="_nav-back">
        <div class="_nav-back__icon">
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 0C6.28413 0 0 6.28413 0 14C0 21.7159 6.28413 28 14 28C21.7159 28 28 21.7159 28 14C28 6.28413 21.7159 0 14 0ZM15.0889 20.1603C14.8398 20.2223 14.6222 20.2223 14.3731 20.2223C14.6222 20.2539 14.8714 20.1907 15.0889 20.1603C16.738 19.8176 17.9509 18.3872 17.9509 16.6444C17.9509 14.6538 16.3333 13.0667 14.3414 13.0667V14.8398L11.3238 13.0667L8.27468 11.2936L14.3731 7.74754V9.49026C17.3286 9.49026 19.7556 11.8856 19.7556 14.8728C19.7556 17.578 17.7018 19.8179 15.089 20.1604L15.0889 20.1603Z"
              fill="var(--headerTextColor)"
            />
          </svg>
        </div>
        <span
          class="_nav-back__text"
          [innerText]="appConfig.settings.header_menu[0].title"
        ></span>
      </div>
    </a>
    <app-back-button *ngIf="notMain" [forHeader]="true"></app-back-button>
    <div
      class="_logo"
      *ngIf="appConfig.settings.header_menu.length === 0 || notMain"
    >
      <a [routerLink]="['/']">
        <img
          [src]="
            ToolsHelper.minLogoUrl(
              appConfig.configsUrl,
              appConfig.settings.logo
            ) +
            '?v=' +
            nowDate
          "
          alt="logo"
        />
        <span>{{ appConfig.settings.page_title }}</span>
      </a>
    </div>

    <div class="_buttons">
      <app-your-tickets
        *ngIf="user"
        [wlMode]="true"
        [opened]="activedMenuItem === ActiveMenuItemEnum.TICKETS"
        (toggleMenu)="toggleMenuHandler($event, ActiveMenuItemEnum.TICKETS)"
      ></app-your-tickets>
      <app-your-coupons
        *ngIf="user"
        [wlMode]="true"
        [opened]="activedMenuItem === ActiveMenuItemEnum.DEALS"
        (toggleMenu)="toggleMenuHandler($event, ActiveMenuItemEnum.DEALS)"
      ></app-your-coupons>
      <app-trip-plan [wlMode]="true"></app-trip-plan>
      <app-auth
        [wlMode]="true"
        [opened]="activedMenuItem === ActiveMenuItemEnum.AUTH"
        (toggleMenu)="toggleMenuHandler($event, ActiveMenuItemEnum.AUTH)"
      ></app-auth>
    </div>

    <div class="_mobile-menu">
      <button
        class="bm-button bm-open-button bm-open-button--box"
        (click)="openMobileMenu($event)"
        [translate]="'menu'"
      ></button>
      <div
        class="_mobile-menu__buttons"
        *ngIf="mobileMenuShow"
        (click)="mobileMenuShow = false"
      >
        <button
          class="bm-button bm-open-button bm-open-button--box"
          (click)="openMobileMenu($event); $event.stopPropagation()"
          [translate]="'menu'"
        ></button>
        <app-auth
          [wlMode]="true"
          [boxBtnMode]="true"
          [opened]="activedMenuItem === ActiveMenuItemEnum.AUTH"
          (toggleMenu)="toggleMenuHandler($event, ActiveMenuItemEnum.AUTH)"
          (click)="$event.stopPropagation()"
        ></app-auth>
        <app-trip-plan
          [wlMode]="true"
          [boxBtnMode]="true"
          (navigateClicked)="mobileMenuShow = false"
          (click)="$event.stopPropagation()"
        ></app-trip-plan>
        <app-your-tickets
          *ngIf="user"
          [wlMode]="true"
          [boxBtnMode]="true"
          [opened]="activedMenuItem === ActiveMenuItemEnum.TICKETS"
          (toggleMenu)="toggleMenuHandler($event, ActiveMenuItemEnum.TICKETS)"
          (click)="$event.stopPropagation()"
        ></app-your-tickets>
        <app-your-coupons
          *ngIf="user"
          [wlMode]="true"
          [boxBtnMode]="true"
          [opened]="activedMenuItem === ActiveMenuItemEnum.DEALS"
          (toggleMenu)="toggleMenuHandler($event, ActiveMenuItemEnum.DEALS)"
          (click)="$event.stopPropagation()"
        ></app-your-coupons>
        <div
          class="bm-header-btn-wrapper bm-header-btn-wrapper--wl-mode"
          (click)="$event.stopPropagation()"
        >
          <button
            *ngIf="user"
            class="bm-button bm-open-button bm-open-button--box _logout"
            [translate]="'logout'"
            (click)="logout()"
          ></button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
